import { render } from "./StaffList.vue?vue&type=template&id=5838f326&scoped=true"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"

import "./StaffList.vue?vue&type=style&index=0&id=5838f326&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5838f326"]])

export default __exports__